import { makeAutoObservable, observable, action, runInAction } from "mobx";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { toast } from "react-toastify";
import { IUsers, IChangeState } from "../models/user";
import { showError } from "../util/errorTypeEnumsOptions";

export default class UserCompanyStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable users: IUsers[] = [];
  @observable loadData = false;

  @action getUsers = async () => {
    try {
      const us = await agent.UserCompany.getUsers();
      runInAction(() => {
        this.users = us;
      });
    } catch (error) {
      showError(error);
    }
    runInAction(() => {
      this.loadData = true;
    });
  };

  @action createUser = async (values: any) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      const user = await agent.UserCompany.createUser(values);
      if (user) {
        toast.success(
          "Usuario creado satisfactoriamente. Se envía mail para crear contraseña"
        );
        this.rootStore.modalStore.closeModal();
        this.getUsers();
      } else toast.error("UPS! No se pudo crear el usuario");
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action changeState = async (userChangeState: IChangeState) => {
    try {
      const change = await agent.UserCompany.changeUserState(userChangeState);
      if (change) {
        toast.success("Se ha cambiado el estado correctamente");
        this.getUsers();
      } else toast.error("UPS! No se pudo cambiar el estado");
    } catch (error) {
      showError(error);
    }
  };

  @action checkUsername = async (username: string) => {
    try {
      return await agent.UserCompany.getCheckRegister(username);
    } catch (error) {
      console.log(error.response.data.ErrorCode);
      return false;
    }
  };

  @action editAdminUser = async (id: any, values: any) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      await agent.UserCompany.editUser(id, values);
      toast.success("El usuario se ha actualizado correctamente");
      this.rootStore.modalStore.closeModal();
      this.getUsers();
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };
}
